import moment from 'moment'

export const extractMonth = date => {
  const y = date.year
  const m = date.month
  const beginningOfMonth = moment(
    new Date(y, m.index, 1, 0, 0, 0, 0).toISOString()
  ).format('YYYY-MM-DD HH:mm:ss')
  const endOfMonth = moment(
    new Date(y, m.index, m.length, 23, 59, 59, 999).toISOString()
  ).format('YYYY-MM-DD HH:mm:ss')
  return { beginningOfMonth, endOfMonth }
}
